import React, { useState, useContext, useEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import MUIDataTable from 'mui-datatables';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { mutate as GlobalMutate } from 'swr';
import { useFetch } from '../../components/hooks/useFetch';
import { columns } from './columns';
import colourStyles from '../../components/selectAsync/colourStyles';
import { Context } from '../../services/context';
import api from '../../services/api';
import { Prefix } from '../../services/prefix';
import { getTableOptions, handleDelete } from './utils';
import { AsyncPaginate } from 'react-select-async-paginate';

export const EquipmentView = ({ idContractItem }) => {

  const { employeeView, setEmployeeView } = useContext(Context);

  const [pagina, setPagina] = useState(0);
  const [perPage, setPerPage] = useState(15);
  const [search, setSearch] = useState('');
  const [alerts, setAlerts] = useState([]);
  const [valueSelect, setValueSelect] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  /** Buscar alertas **/
  const fetchAlerts = async () => {
    try {
      const res = await api.get(`${Prefix.replace(/[\\"]/g, '')}/alerts`);

      const list =
        res.data?.models?.data?.map(a => ({
          value: a.value === true || a.value === 'true',
          label: a.name
        })) ?? [];

      setAlerts(
        list.length
          ? list
          : [
            { value: true, label: 'Sim' },
            { value: false, label: 'Não' }
          ]
      );
    } catch {
      setAlerts([
        { value: true, label: 'Sim' },
        { value: false, label: 'Não' }
      ]);
    }
  };

  useEffect(() => {
    fetchAlerts();
  }, []);

  /** 🔹 Carregar tabela **/
  const listEquipmentView = useFetch(
    `${Prefix.replace(/[\\"]/g, '')}/contract-item-views?per_page=${perPage}&page=${pagina + 1}&id_contract_item=${idContractItem}`,
    [pagina, perPage, search, idContractItem]
  );

  /** 🔹 Load Users só quando abrir/pesquisar no select */
  const loadUsers = async (search, loadedOptions, { page }) => {
    try {
      const res = await api.get(
        `${Prefix.replace(/[\\"]/g, '')}/users`,
        {
          params: {
            page: page || 1,
            search: search || ''
          }
        }
      );

      const list = res?.data?.models?.data ?? [];

      return {
        options: list.map(u => ({
          value: u.id,
          label: u.name
        })),
        hasMore: res.data.models.current_page < res.data.models.last_page,
        additional: {
          page: (page || 1) + 1
        }
      };
    } catch (error) {
      return {
        options: [],
        hasMore: false,
        additional: {
          page: 1
        }
      };
    }
  };


  const handleClose = () =>
    setEmployeeView({ ...employeeView, equipmentView: false, employees: true });

  const tableOptions = getTableOptions({
    pagina,
    perPage,
    listEquipmentView,
    HandleDelete: handleDelete,
    setPagina,
    setPerPage
  });

  /** Select genérico **/
  const HandleSelect = (selected, nameField) => {
    setValueSelect(prev => {
      const filtered = prev.filter(p => p.nameField !== nameField);
      if (!selected) return filtered;
      return [...filtered, { nameField, value: selected.value, label: selected.label }];
    });
  };

  /** Registrar vínculo **/
  const HandleRegister = async () => {
    if (!selectedUser) return;

    setIsSubmitting(true);

    const formData = {
      warning: valueSelect.find(v => v.nameField === 'warning')?.value ?? false,
      danger: valueSelect.find(v => v.nameField === 'danger')?.value ?? false,
      dark: valueSelect.find(v => v.nameField === 'dark')?.value ?? false
    };

    try {
      const response = await api.post(
        Prefix.replace(/[\\"]/g, '') + '/contract-item-views',
        {
          id_user: Number(selectedUser.value),
          id_contract_item: Number(idContractItem),
          warning: Boolean(formData.warning),
          danger: Boolean(formData.danger),
          dark: Boolean(formData.dark)
        }
      );

      await GlobalMutate(
        Prefix.replace(/[\\"]/g, '') +
        `/contract-item-views?per_page=${perPage}&page=${pagina + 1}&search=${search}&id_user=${selectedUser.value}`
      );

      Swal.fire({
        icon: 'success',
        title: 'Uow!',
        text: response.data.message,
        confirmButtonText: 'Fechar'
      });
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Ops...',
        text: err?.response?.data?.message || 'Erro',
        confirmButtonText: 'Tentar novamente'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* 🔹 Título seção cadastro */}
      <h5 className="mb-4 mt-3"><b>Cadastrar permissão</b></h5>

      <Row className="mt-2 mb-3">
        <Col md={6}>
          <label className="important">Usuário</label>
          <AsyncPaginate
            value={selectedUser}
            onChange={setSelectedUser}
            loadOptions={loadUsers}
            additional={{
              page: 1
            }}
            placeholder="Selecione o Usuário"
            styles={colourStyles}
          />
        </Col>
      </Row>

      <Row style={{ marginTop: 14 }}>
        <Col md={4}>
          <div className="formStep">
            <label className="important">Receber alerta médio?</label>
            <Select
              value={valueSelect
                .filter(fill => fill.nameField === 'warning')
                .map(map => ({ value: map.value, label: map.label }))}
              styles={colourStyles}
              onChange={e => HandleSelect(e, 'warning')}
              placeholder="Selecione..."
              options={alerts}
            />
          </div>
        </Col>

        <Col md={4}>
          <div className="formStep">
            <label className="important">Receber alerta urgente?</label>
            <Select
              value={valueSelect
                .filter(fill => fill.nameField === 'danger')
                .map(map => ({ value: map.value, label: map.label }))}
              styles={colourStyles}
              onChange={e => HandleSelect(e, 'danger')}
              placeholder="Selecione..."
              options={alerts}
            />
          </div>
        </Col>

        <Col md={4}>
          <div className="formStep">
            <label className="important">Receber alerta grave?</label>
            <Select
              value={valueSelect
                .filter(fill => fill.nameField === 'dark')
                .map(map => ({ value: map.value, label: map.label }))}
              styles={colourStyles}
              onChange={e => HandleSelect(e, 'dark')}
              placeholder="Selecione..."
              options={alerts}
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col className="d-flex justify-content-center mt-4 mb-3">
          <Button
            type="button"
            style={{
              backgroundColor: '#1bc5bd',
              width: '160px',
              height: '60px',
              border: 0,
              borderRadius: '30px',
              marginTop: '20px'
            }}
            onClick={HandleRegister}
            disabled={isSubmitting}
          >
            Vincular
          </Button>
        </Col>
      </Row>

      {/* 🔹 Título seção tabela */}
      <h5 className="mb-2 mt-4"><b>Permissões vinculadas</b></h5>

      <div style={{ position: 'relative', zIndex: 0, marginTop: 10 }}>
        <MUIDataTable
          data={listEquipmentView.data?.models?.data || []}
          columns={columns}
          options={tableOptions}
        />
      </div>

      <Row>
        <Col className="d-flex justify-content-center mt-4 mb-3">
          <Button
            type="button"
            style={{
              backgroundColor: '#1bc5bd',
              width: 160,
              height: 60,
              border: 0,
              borderRadius: 30
            }}
            onClick={handleClose}
          >
            Voltar
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default EquipmentView;
